// components/StoreProvider.tsx
"use client";

import { useRef } from 'react';
import { 
  createKernelStore, 
  KernelStoreContext, 
  type KernelStoreApi,
} from '@/kernel/kernelStores';

interface StoreProviderProps {
  children: React.ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  const kernelStoreRef = useRef<KernelStoreApi | null>(null);

  if (!kernelStoreRef.current) {
    kernelStoreRef.current = createKernelStore();
  }

  return (
    <KernelStoreContext.Provider value={kernelStoreRef.current}>
      {children}
    </KernelStoreContext.Provider>
  );
};